"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _EmphasizeText = require("./EmphasizeText");
Object.keys(_EmphasizeText).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EmphasizeText[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EmphasizeText[key];
    }
  });
});
